import { HttpClientModule } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { ApolloLink, InMemoryCache, split } from '@apollo/client/core'
import { setContext } from '@apollo/client/link/context'
import { WebSocketLink } from '@apollo/client/link/ws'
import { getMainDefinition } from '@apollo/client/utilities'
import { APOLLO_OPTIONS } from 'apollo-angular'
import { HttpLink } from 'apollo-angular/http'
import { OperationDefinitionNode } from 'graphql'
import { environment } from '../../../environments/environment'
import { PAPI_AUTH_TOKEN } from '../auth/auth.service'

const httpUri = `${environment.API}/graphql`
const wsUri = `${environment.WS}/graphql`

export function createApollo(httpLink: HttpLink) {
  const auth = setContext(() => {
    const token = localStorage.getItem(PAPI_AUTH_TOKEN)
    return token ? { headers: { Authorization: `Bearer ${token}` } } : {}
  })

  // Create an http link:
  const http = ApolloLink.from([auth, httpLink.create({ uri: httpUri })])

  // Create a WebSocket link:
  const ws = new WebSocketLink({
    uri: wsUri,
    options: {
      reconnect: true,
      lazy: true,
      connectionParams: () => {
        const token = localStorage.getItem(PAPI_AUTH_TOKEN)
        return { headers: { Authorization: `Bearer ${token}` } }
      },
    },
  })

  return {
    link: split(isWebSocket, ws, http),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
      },
    },
  }

  function isWebSocket({ query } /* : Operation */) {
    // split based on operation type
    const { kind, operation } = getMainDefinition(query) as OperationDefinitionNode
    return kind === 'OperationDefinition' && operation === 'subscription'
  }
}

@NgModule({
  exports: [HttpClientModule],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink],
    },
  ],
})
export class GraphQLModule {}
